export const Stages = {
    FIRST: 'firstStageEditor',
    SECOND: 'secondStageEditor'
}
export const FieldPoints = {
    FIELD: 'points',
    ZONE: 'zone'
}

export const FieldMarkingHintsConstant = {
    DEFAULT: `Режим просмотра видео. Для разметки поля — 2 этапа:

Этап №1 — Разметка поля:
    1. Нажмите «Режим редактирования»
    2. Укажите длину и ширину поля (см)
    3. Расставьте 4-9 точек на поле

Этап №2 — Разметка зон (опционально):
    1. Нажмите «Этап 2»
    2. Укажите размеры штрафной, вратарской, ворот
    3. Расставьте точки углов штрафных, вратарских и штанг ворот

Управление:
    • Scroll — масштабирование (zoom)
    • Space + перетаскивание — перемещение (pan)
    • Двойной клик — сброс масштаба`,
    FIRST_STAGE: `Этап 1 — Разметка поля

    1. Укажите длину и ширину поля в сантиметрах
    2. Расставьте точки на поле (4, 6 или 9 точек)

    Scroll — zoom, Space+drag — pan, двойной клик — сброс zoom

    После расстановки точек станет доступен Этап 2 (разметка зон).`,
    SECOND_STAGE: `Этап 2 — Разметка зон поля (опционально)

    Укажите реальные размеры зон и расставьте точки на видимых зонах:

    • Штрафная площадь — 4 угла на каждую видимую сторону (красные точки)
    • Вратарская площадь — 4 угла на каждую видимую сторону (синие точки)
    • Ворота — 2 штанги на каждую видимую сторону (жёлтые точки)

    Все зоны опциональны — размечайте только видимые.
    Scroll — zoom, Space+drag — pan, двойной клик — сброс zoom`
}
